

























































import { Component, Vue } from 'vue-property-decorator'
import { queryDictsByCode, queryShareByType, queryCourseType, getCourse, addLearnRecord, addFinishLearnRecord } from '@/api/api'
import styleDialog from '@/components/styleDialog.vue'

@Component({
  components: {
    styleDialog
  }
})
export default class Share extends Vue {
  shareTypeList: Array<any> = [] // 分享类型列表
  fileList: Array<any> = [] // 文件列表
  currentType: string = '' // 当前类型
  currentTypeIndex: number = 0 // 当前类型index
  pageSize: number = 15 // 分页组件的page-size
  total: number = 0 // 分页组件的total
  dialogVisible: Boolean = false // 是否显示文件模态框
  checkFile: any = {
    id: '', // 课程ID
    name: '', // 课程名字
    url: '' // 课程地址
  }

  mounted() {
    this._onload().finally(() => {
      this._loading().close()
    })
  }

  /**
   * 选择分享
   * @param id    课程ID
   * @param index 当前课程的index
   */
  selectShareType(id: string, index: number): void {
    this.currentTypeIndex = index

    this._queryShareByType(id)

    this.currentType = id
  }

  /**
   * 在新标签页打开课程文件
   * @param file // 文件信息
   */
  openFile(file: any): void {
    this._addLearnRecord(file.id)
    if (file.fileType === 'pdf') {
      this.dialogVisible = true
      this.checkFile.id = file.id
      this.checkFile.name = file.name
      this.checkFile.url = file.filekUrl
      this.checkFile.type = file.fileType
    } else {
      window.open(file.filekUrl)
      this._addFinishLearnRecord(file.id)
    }
  }

  /**
   * 完成学习
   */
  completeLearn(e: any): void {
    this.dialogVisible = !this.dialogVisible
  }

  /**
   * 换页
   */
  changePage(page: number): void {
    this._queryShareByType(this.currentType, page)
  }

  async _onload(): Promise<any> {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    await this._queryDictsByCode()
    await this._queryShareByType(this.shareTypeList[0].id)
  }

  /**
   * 获取分享类型
   */
  async _queryDictsByCode(): Promise<any> {
    return queryDictsByCode({ parent_code: 'share' }).then((res: any) => {
      if (res.data.code === 101) {
        const arr = res.data.result
        for (let i = 0, len = arr.length; i < len; i++) {
          this.shareTypeList.push({
            name: arr[i].code_value,
            id: arr[i].code
          })
        }
      }
    })
  }

  /**
   * 查询分享课程
   */
  async _queryShareByType(type_code: string, page: number = 1, size: number = this.pageSize): Promise<any> {
    this._loading()
    return queryShareByType({
      type_code,
      page,
      size
    })
      .then((res: any) => {
        const arr = res.data.result.records
        this.fileList = []
        for (let i = 0, len = arr.length; i < len; i++) {
          this.fileList.push({
            id: arr[i].shareId,
            name: arr[i].shareName,
            author: arr[i].shareUser,
            fileType: arr[i].shareFileType,
            filekUrl: arr[i].linkUrl,
            linkCoverUrl: arr[i].linkCoverUrl
          })
        }
        this.total = res.data.result.total
      })
      .finally(() => {
        this._loading().close()
      })
  }

  /**
   * 接口 添加学习记录
   * @param course_id 课程ID
   */
  _addLearnRecord(id: string): void {
    addLearnRecord({ course_id: id })
  }

  /**
   * 接口 添加完成学习记录
   * @param course_id 课程ID
   */
  _addFinishLearnRecord(id: string): void {
    addFinishLearnRecord({ course_id: id })
  }

  /**
   * 显示loading
   */
  _loading(text: string = '加载中'): any {
    const vm = this

    this.$loading({
      lock: true,
      text: text,
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
